import {saveVuexState, getVuexState, addToUrlQuery} from '../../../util/common'


export default function(state_name){

    const saveState = (state) => {
        saveVuexState(state_name, state)
    }

    const state = getVuexState(state_name, {
        stack: [],
        last_state_key: '',
    });

// getters
    const getters = {
        stack: state => state.stack,
        current: state => {
            let current_state = null;
            if (state.last_state_key && state.stack.length) {
                state.stack.forEach(item => {
                    if (!current_state && item.source_key === state.last_state_key) {
                        current_state = item
                    }
                })
            }
            return current_state
        },
    };

// actions
    const actions = {
        /**
         * run this in created hook for SingleVehicle.vue
         *
         * @param state_key should be window.history.state.key
         */
        checkStack({commit, state, getters}, state_key = null){
            if (!state_key) {
                const historyState = window.history.state
                state_key = historyState.key || null
            }
            let found = false
            state.stack.forEach(item => {
                if (!found && (item.source_key === state_key
                    || item.state_keys.indexOf(state_key) !== -1)) {
                    found = item
                    commit('setLastKey', state_key)
                }
            })
            return found;
        },
        /**
         * Run this in the created hook for the vehicle list component
         * @param commit
         * @param state
         * @param getters
         * @param state_key
         * @returns {boolean}
         */
        checkListReturn({commit, state, getters}, state_key = null){
            if (!state_key) {
                const historyState = window.history.state
                state_key = historyState.key || null
            }
            let found = false
            console.log('checkListReturn running');
            state.stack.forEach(item => {
                if (!found && (item.source_key === state_key
                    || item.state_keys.indexOf(state_key) !== -1)) {
                    if (item.scroll_position) {
                        document.documentElement.scrollTop = item.scroll_position;
                    }
                }
            })
            return found;
        },
        addToStack({commit, state}, {ids}) {
            const historyState = window.history.state
            const state_key = historyState.key || null
            if (state_key) {
                let current_state = null;
                state.stack.forEach(item => {
                    if (!current_state && item.source_key === state_key) {
                        current_state = state
                    }
                })
                if (!current_state) { //only add it if we didn't already add it before
                    const newItem = {
                        ids,
                        source_key: state_key,
                        state_keys: [state_key],
                        scroll_position: 0,
                        back_to_all: null,
                    }
                    commit('addToStack', {
                        item: newItem,
                        state_key
                    })
                } else { //otherwise just update the ids
                    commit('setStackIds', {state_key, ids})
                }
            }
        },
        /**
         * This should be used in the SingleVehicle.vue mounted
         * @param state
         * @param state_key
         */
        addSingleVehicleToCurrent({commit, state, getters}, state_key = null){
            if (!state_key) {
                const stateHistory = window.history.state
                state_key = stateHistory.key || null
            }
            if (state_key) {
                const current = getters['current']
                if (current) {
                    commit('addKeyToState', {
                        source_key: current.source_key,
                        state_key
                    })
                }
            }
        },
        leavingListPage({commit, state}, params = {}) {
            let {
                back_to_all = null,
                scroll_top = null
            } = params
            const historyState = window.history.state
            const state_key = historyState.key || null
            if (state_key) {
                if (!scroll_top) {
                    const doc = document.documentElement;
                    scroll_top = (window.pageYOffset || doc.scrollTop)  - (doc.clientTop || 0);
                }
                if (!back_to_all) {
                    back_to_all = addToUrlQuery(window.location.pathname + window.location.search, {state_key})
                }
                if (state.stack.length) {
                    commit('setLeavingProperties', {state_key, scroll_top, back_to_all})
                }
            }
        },
    };
    const mutations = {
        addToStack(state, {item, state_key}) {
            if (state.stack.length > 20) {
                state.stack.shift()
            }
            state.stack.push(item)
            state.last_state_key = state_key
            saveState(state)
        },
        setStackIds(state, {ids, state_key}) {
            let found = null;
            if (state.stack.length) {
                state.stack.forEach(item => {
                    if (!found && item.source_key === state_key) {
                        found = true
                        item.ids = ids
                    }
                })
            }
            saveState(state)
        },
        setLastKey(state, key){
            state.last_state_key = key
            saveState(state)
        },
        addKeyToState(state, {source_key, state_key}){
            let current_state = null;
            if (source_key && state.stack.length) {
                state.stack.forEach(item => {
                    if (!current_state && item.source_key === source_key) {
                        current_state = item
                    }
                })
            }
            if (current_state) {
                if (current_state.state_keys.indexOf(state_key) === -1) {
                    current_state.state_keys.push(state_key)
                }
            }
            saveState(state)
        },
        setLeavingProperties(state, {state_key, scroll_top, back_to_all}) {
            let found = null;
            if (state.stack.length) {
                state.stack.forEach(item => {
                    if (!found && item.source_key === state_key) {
                        found = true
                        if (scroll_top) {
                            item.scroll_position = scroll_top
                        }
                        if (back_to_all) {
                            item.back_to_all = back_to_all
                        }

                    }
                })
            }
        },
    }

    return {
        saveState,
        state,
        getters,
        actions,
        mutations
    }
}



// WEBPACK FOOTER //
// ./resources/js/store/modules/common/next_prev.js